import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import AboutUs from "./components/Pages/AboutUs";
import BoardMembers from "./components/Pages/BoardMembers";
import Login from "./components/Pages/Login";
import Signup from "./components/Pages/Signup";
import Profile from "./components/Pages/Profile";
import "./App.css";

import SubPillars from "./components/Pages/Sub_Pillars";
import Contact from "./components/Pages/Contact";
import Events from "./components/Pages/Events";
import JoinPage from "./components/Pages/JoinPage";
import ViewPage from "./components/Pages/ViewPage";
import Footer from "./components/Footer";
import Announcement from "./components/Pages/Announcement";

function App() {

  const handleLoginClick = () => {
    console.log("Login button clicked!");
  };

  return (
    <div className="page-wrapper">
      <Router>
        <Routes>
          <Route path="/" element={<Home onLoginClick={handleLoginClick} />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/board-members" element={<BoardMembers />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/Sub_Pillars" element={<SubPillars />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/events" element={<Events />} />
          <Route path="/join/:name" element={<JoinPage />} />
          <Route path="/view/:name" element={<ViewPage />} />
          <Route path="/announcement" element={<Announcement />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
